import React, { useState, useEffect } from 'react';
import axios from 'axios'
import Select from 'react-select';
import './form.css';

import { AddRevenue } from '../../Redux/action/revenueAction';

import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import { getLocationNameById } from '../../utils/getLocationNameById';
import { toast } from 'react-toastify';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwRadio from '../Common/FormComponent/SwRadio'
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwButton from '../Common/SwButtons/SwButtons';

let count = 0;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()
class MealPlanServiceRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pax: null,
            location: '',
            locationError: '',
            location1: '',
            locationData: [],
            locationNew: [],
            locationId: null,
            notes: '',
            typeOfMeal: null,
            typeOfMealError: '',
            noOfPeople: '',
            budget: '',
            company_id: UserObj ? UserObj.company_id : null,
            userid: UserObj ? UserObj.rec_id : null,
            email: UserObj ? UserObj.email : null,
            files: null,
            attachmentError: '',
            btnStatus: false,
            selectedFile: undefined,
            selectedFileName: undefined,
            imageSrc: undefined,
            value: '',
        };
    }

    changeSelect = (e) => {
        if (!e) {
            this.setState({
                location: null,
                location1: "",
                locationId: "",
                locationError: "",
            });
            return;
        }

        this.setState({
            location: e,
            location1: String(e.label),
            locationId: e.value,
            locationError: "",
        });
    };

    handleNoOfPeopleChange = (event) => {
        this.setState({ noOfPeople: event.target.value });
    };

    handleBudgetChange = (event) => {
        this.setState({ budget: event.target.value });
    };

    onNotes = e => {
        this.setState({
            notes: e?.target?.value,
            noteError: ''
        });
    };

    handleTypeOfMeal = (selectedMeal) => {
        if (selectedMeal.length === 0) {
            this.setState({
                typeOfMeal: selectedMeal,
                typeOfMealError: 'Type Of Meal cannot be empty'
            });
            toast.error('Type Of Meal cannot be empty');
        } else {
            this.setState({
                typeOfMeal: selectedMeal,
                typeOfMealError: ''
            });
        }
    };
    resetValue = () => {
        this.setState({
            notes: '',
            location: null,
            locationError: '',
            noOfPeople: null,
            budget: null,
            typeOfMeal: [],   // ✅ FIX
            typeOfMealError: '',
            selectedFile: undefined,
            selectedFileName: undefined,
            imageSrc: undefined,
            value: ''
        });
    };


    componentDidMount() {
        var LocationSpoc = JSON.parse(userDataLocal12);
        let locationShort = JSON.parse(locationWithShortName)
        this.setState({ locationNew: locationShort })
        this.setState({
            locationData: LocationSpoc,
        });
    }

    options1 = [
        { value: 'breakfast', label: 'Breakfast' },
        { value: 'lunch', label: 'Lunch' },
        { value: 'snacks', label: 'Snacks' },
        { value: 'dinner', label: 'Dinner' },
    ];

    handleFile(e) {

        if (e.target.files[0]) {
            this.setState({
                selectedFile: e.target.files[0],
                selectedFileName: e.target.files[0].name,
                imageSrc: window.URL.createObjectURL(e.target.files[0]),
                value: e.target.value,
            });
        }

        // Getting the files from the input
        this.setState({ files: e.target.files });

        if (e.target.files.length > 2) {
            this.setState({ attachmentError: "Attachment can't be more than 2" });
        }
        else if (e.target.files.length <= 2) {
            this.setState({ attachmentError: "" });
        }
    }

    handleSubmit = e => {
        e.preventDefault();
        const { noOfPeople, budget, typeOfMeal } = this.state;

        let files = this.state.files;
        let formData = new FormData();
        if (files && files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                formData.append('file', files[i]);
            }
        }

        if (this.state.location === null || this.state.location === '') {
            this.setState({ locationError: "Location can't be empty" });
            return;
        }

        else if (!noOfPeople) {
            toast.error('Number of people cannot be empty');
        }
        else if (!budget) {
            toast.error('Budget cannot be empty');
        }
        else if (!typeOfMeal || typeOfMeal.length === 0) {
            this.setState({ typeOfMealError: 'Type Of Meal cannot be empty' });
            toast.error('Type Of Meal cannot be empty');
        }
        else if (this.state.files != null && this.state.files.length > 2) {
            this.setState({ attachmentError: "Attachment can't be more than 2" });
        }
        else {
            e.currentTarget.disabled = true;
            let param = {};
            let typeOfMealValues = typeOfMeal.map(option => option.value).join(', ');
            let common_param = {
                company_id: this.state.company_id,
                spoc_id: this.state.userid,
                email: this.state.email,
                category: 'meal_plan',
                company_name: UserObj ? UserObj.company_name : null
            };
            let body_param = {
                location_name: this.state.location1,
                no_of_people: noOfPeople,
                budget: budget,
                type_of_meal: typeOfMealValues,
                notes: this.state.notes,
            };
            param.common_param = common_param;
            param.body_param = body_param;
            AddRevenue(param, (success, message) => {
                console.log(success, message, "khushburani");
                if (success) {
                    toast.success(message);
                    this.resetValue();
                    if (this.props.onClose) {
                        this.props.onClose();
                    }
                }
                this.setState({ btnStatus: false });
                e.currentTarget.disabled = false;
            });
        }
    };

    render() {
        const noOfPeopleOptions = ['1-100', '100-250', '250-500', '500-1000', '>1000'];
        const budgetOptions = ['55-100', '100-150', '150-200', '>200'];
        return (
            <>
                <div className="row">
                    <div className="col-md-12 ">
                        <div className="SwFormGroup">
                            <label className='SwFormLabel'>Location <span className="Required">*</span></label>
                            <SwSelect
                                name="location"
                                value={this.state.location}
                                onChange={this.changeSelect}
                                options={this.state.locationData}
                                id="mealplan-location-select"
                                isClearable={false}
                            />
                            <span className="SwTextDanger SwTextSmall">
                                {this.state.locationError}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row" >
                    <div className="col-md-12">
                        <div className="SwFormGroup">
                            <label className="SwFormLabel">
                                No. of people <span className="Required">*</span>
                            </label>

                            {noOfPeopleOptions.map((option, index) => (
                                <div key={index}>
                                    <SwRadio
                                        id={`customRadio${index}`}
                                        name="NoPeople"
                                        label={option}
                                        value={option}
                                        checked={this.state.noOfPeople === option}
                                        onChange={this.handleNoOfPeopleChange}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="SwFormGroup">
                            <label className="SwFormLabel">
                                Budget per day in INR <span className="Required">*</span>
                            </label>

                            {budgetOptions.map((option, index) => (
                                <div key={index}>
                                    <SwRadio
                                        id={`Budget${index}`}
                                        name="BudgetRadio"
                                        label={option}
                                        value={option}
                                        checked={this.state.budget === option}
                                        onChange={this.handleBudgetChange}
                                    />

                                    {this.state.budgetError && (
                                        <span className="SwTextDanger SwTextSmall"> {this.state.budgetError}</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="col-md-12">
                        <div className="SwFormGroup">
                            {' '}
                            <label className="SwFormLabel">Type Of Meal <span className="Required">*</span></label>{' '}
                            <SwSelect
                                id="mealplan-meal-select"
                                placeholder="Select"
                                options={this.options1}
                                value={this.state.typeOfMeal}
                                onChange={this.handleTypeOfMeal}
                                isMulti
                            />{' '}
                            <span className="SwTextDanger SwTextSmall">
                                {this.state.typeOfMealError}
                            </span>
                        </div>
                    </div>{' '}
                </div>

                <div className="row">
                    <div className="col-md-12 col-xl-12 col-lg-12 ">
                        <div className="SwFormGroup">
                            <label className="SwFormLabel">Notes</label>
                            <SwTextArea
                                rows="4"
                                value={this.state.notes}
                                onChange={this.onNotes}
                                id="mealplan-notes"
                            />
                            <span className="SwTextDanger SwTextSmall">
                                {this.state.noteError}
                            </span>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default MealPlanServiceRequest;
